



export function formData(elements, keys) {
	
	if (!elements || !elements.length) return {}

	const counts = elements.reduce((count, { name }) => {
		if (name) count[name] = count[name] ? count[name] + 1 : 1;
		return count
	}, {})

	const fields = elements.reduce((data, { name, value, type, checked }) => {
		
		// only include named fields, or fields referenced in `keys` array
		if (!name) return data
		if (Array.isArray(keys) && !keys.includes(name)) return data
		if (typeof keys === 'string' && keys !== name) return data

		// carry across previous values for multiple types
		const previous = (typeof data[name] !== 'undefined') ? data[name] : undefined	

		// radios should always return a single value
		if (type === 'radio') {
			if (checked) data[name] = value
			if (!checked) data[name] = previous || null
			return data
		}

		// if multiple, convert to an array, and carry data from previous iteration
		const multiple = (counts[name] > 1)
		if (multiple) data[name] = previous || []
		if (!multiple) data[name] = previous
		
		// checkboxes
		if (type === 'checkbox') {
			if (multiple && checked) data[name].push(value)
			if (!multiple && checked) data[name] = value
			if (!multiple && !checked) data[name] = null
			return data
		}

		if (multiple) data[name].push(value)
		if (!multiple) data[name] = value
		return data
	}, {})

	if (typeof keys === 'string') return fields[keys]
	return fields
}